import bruteForce from './bruteForce.js';

export const findAll = bruteForce;
export {default as startsWith} from './startsWith.js';
